module.exports = __webpack_public_path__ + "img/saobei.92be297d.png";